module.exports = __webpack_public_path__ + "img/SAVE.417d02d1.svg";